module.exports = __webpack_public_path__ + "assets/Angle3.5ea3996b372690a605dcc8fefc1f72bd.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle3.gmt
// module id = 892
// module chunks = 0